import apiClient from '../../../../../services/apiClient';

/**
 * Get detailed info (name, birth date, etc.) for children currently active
 * in a group as of a given date. Reuses the same endpoint the attendance
 * feature uses to list a group's children.
 */
export const getGroupChildrenInfo = async (kgId, groupId, dateTo = new Date().toISOString()) => {
  const url = `kindergartens/${kgId}/children/main_info?groups=${groupId}&date_to=${dateTo}&period=day`;

  try {
    const response = await apiClient.get(url);
    return response;
  } catch (error) {
    throw new Error(`Error getting group children info: ${error}`);
  }
};

/**
 * Transfer a set of children from a current-period group to a
 * next-period group (i.e. move them into next school year's group).
 *
 * @param {string} kgId
 * @param {string|number} currentPeriodGroupNumber - `number` of the source group
 * @param {string|number} nextPeriodGroupNumber - `number` of the destination (next year) group
 * @param {string[]} childrenIds
 */
export const transferChildrenToNextPeriodGroup = async (
  kgId,
  currentPeriodGroupNumber,
  nextPeriodGroupNumber,
  childrenIds
) => {
  // Номери груп навмисно в query-параметрах, а не в шляху URL: номер групи
  // іноді містить крапки (напр. "03.." — старий артефакт іншого багу), і
  // шлях із підрядком ".." блокується security-фільтром на рівні
  // інфраструктури ще до Node.js.
  const url = `kindergartens/${kgId}/groups/transfer_to_next_period/children`
    + `?current_period_group_number=${encodeURIComponent(currentPeriodGroupNumber)}`
    + `&next_period_group_number=${encodeURIComponent(nextPeriodGroupNumber)}`;

  try {
    const response = await apiClient.post(url, { childrenIds });
    return response;
  } catch (error) {
    throw new Error(`Error transferring children to next period group: ${error}`);
  }
};

/**
 * Cancel a previously made transfer: remove children from a next-period
 * group. Requires the new backend route/controller
 * `removeChildrenFromNextPeriodGroup` (see README).
 *
 * @param {string} kgId
 * @param {string|number} nextPeriodGroupNumber - `number` of the next-year group to remove children from
 * @param {string[]} childrenIds
 */
export const removeChildrenFromNextPeriodGroup = async (
  kgId,
  nextPeriodGroupNumber,
  childrenIds
) => {
  // group_number — так само query-параметром, з тієї ж причини (крапки в
  // номері групи).
  const url = `kindergartens/${kgId}/next_period_group/children/remove`
    + `?group_number=${encodeURIComponent(nextPeriodGroupNumber)}`;

  try {
    const response = await apiClient.post(url, { childrenIds });
    return response;
  } catch (error) {
    throw new Error(`Error removing children from next period group: ${error}`);
  }
};